<template>
  <div class="relative flex items-center justify-center py-32">
      <div class="text-center">
        <div class="relative w-20 h-20 mx-auto mb-6">
          <div class="absolute inset-0 border-4 border-primary-200 rounded-full animate-spin"></div>
          <div class="absolute inset-2 border-4 border-primary-500 border-t-transparent rounded-full animate-spin" style="animation-direction: reverse;"></div>
          <div class="absolute inset-6 rounded-full flex items-center justify-center">
            <img src="@/assets/img/logo.png" alt="">
          </div>
        </div>
        <h3 class="text-xl font-bold text-gray-900 mb-2">Chargement...</h3>
        <p class="text-gray-600">Veuillez patienter</p>
      </div>
    </div>
</template>

<script setup>

// Pas de script nécessaire pour un composant de chargement simple
</script>
